var cov_crec7426n = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Textarea/Textarea.tsx",
      hash = "c69c7c639bc27d184a96090ce1be8d29c739a619",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Textarea/Textarea.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 21
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 16
        }
      },
      "2": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      "3": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 48
        }
      },
      "4": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 48
        }
      },
      "5": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 52
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 50
        }
      },
      "7": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 40
        }
      },
      "8": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 50
        }
      },
      "9": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 29
        }
      },
      "10": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 42
        }
      },
      "11": {
        start: {
          line: 41,
          column: 29
        },
        end: {
          line: 41,
          column: 42
        }
      },
      "12": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 98
        }
      },
      "13": {
        start: {
          line: 45,
          column: 69
        },
        end: {
          line: 45,
          column: 98
        }
      },
      "14": {
        start: {
          line: 49,
          column: 21
        },
        end: {
          line: 49,
          column: 31
        }
      },
      "15": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 39
        }
      },
      "16": {
        start: {
          line: 50,
          column: 28
        },
        end: {
          line: 50,
          column: 39
        }
      },
      "17": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 53
        }
      },
      "18": {
        start: {
          line: 51,
          column: 35
        },
        end: {
          line: 51,
          column: 53
        }
      },
      "19": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 16
        }
      },
      "20": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 49
        }
      },
      "21": {
        start: {
          line: 56,
          column: 38
        },
        end: {
          line: 56,
          column: 49
        }
      },
      "22": {
        start: {
          line: 57,
          column: 21
        },
        end: {
          line: 57,
          column: 31
        }
      },
      "23": {
        start: {
          line: 58,
          column: 17
        },
        end: {
          line: 58,
          column: 44
        }
      },
      "24": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 53
        }
      },
      "25": {
        start: {
          line: 59,
          column: 42
        },
        end: {
          line: 59,
          column: 53
        }
      },
      "26": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 26
        }
      },
      "27": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 20
        }
      },
      "28": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 56
        }
      },
      "29": {
        start: {
          line: 68,
          column: 31
        },
        end: {
          line: 68,
          column: 56
        }
      },
      "30": {
        start: {
          line: 69,
          column: 19
        },
        end: {
          line: 69,
          column: 61
        }
      },
      "31": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 29
        }
      },
      "32": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 39
        }
      },
      "33": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 78,
          column: 5
        }
      },
      "34": {
        start: {
          line: 77,
          column: 6
        },
        end: {
          line: 77,
          column: 33
        }
      },
      "35": {
        start: {
          line: 82,
          column: 29
        },
        end: {
          line: 82,
          column: 39
        }
      },
      "36": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "37": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 62
        }
      },
      "38": {
        start: {
          line: 89,
          column: 19
        },
        end: {
          line: 89,
          column: 33
        }
      },
      "39": {
        start: {
          line: 90,
          column: 36
        },
        end: {
          line: 90,
          column: 46
        }
      },
      "40": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 94,
          column: 5
        }
      },
      "41": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 92,
          column: 32
        }
      },
      "42": {
        start: {
          line: 93,
          column: 6
        },
        end: {
          line: 93,
          column: 31
        }
      },
      "43": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 25
        }
      },
      "44": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 96,
          column: 25
        }
      },
      "45": {
        start: {
          line: 96,
          column: 16
        },
        end: {
          line: 96,
          column: 25
        }
      },
      "46": {
        start: {
          line: 100,
          column: 36
        },
        end: {
          line: 100,
          column: 46
        }
      },
      "47": {
        start: {
          line: 101,
          column: 4
        },
        end: {
          line: 101,
          column: 74
        }
      },
      "48": {
        start: {
          line: 101,
          column: 63
        },
        end: {
          line: 101,
          column: 74
        }
      },
      "49": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "50": {
        start: {
          line: 110,
          column: 21
        },
        end: {
          line: 110,
          column: 31
        }
      },
      "51": {
        start: {
          line: 111,
          column: 22
        },
        end: {
          line: 111,
          column: 46
        }
      },
      "52": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 60
        }
      },
      "53": {
        start: {
          line: 113,
          column: 49
        },
        end: {
          line: 113,
          column: 60
        }
      },
      "54": {
        start: {
          line: 115,
          column: 21
        },
        end: {
          line: 115,
          column: 56
        }
      },
      "55": {
        start: {
          line: 116,
          column: 16
        },
        end: {
          line: 116,
          column: 42
        }
      },
      "56": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 25
        }
      },
      "57": {
        start: {
          line: 119,
          column: 14
        },
        end: {
          line: 119,
          column: 25
        }
      },
      "58": {
        start: {
          line: 121,
          column: 20
        },
        end: {
          line: 121,
          column: 40
        }
      },
      "59": {
        start: {
          line: 122,
          column: 17
        },
        end: {
          line: 122,
          column: 44
        }
      },
      "60": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 131,
          column: 5
        }
      },
      "61": {
        start: {
          line: 147,
          column: 8
        },
        end: {
          line: 147,
          column: 18
        }
      },
      "62": {
        start: {
          line: 148,
          column: 18
        },
        end: {
          line: 148,
          column: 56
        }
      },
      "63": {
        start: {
          line: 149,
          column: 19
        },
        end: {
          line: 149,
          column: 46
        }
      },
      "64": {
        start: {
          line: 150,
          column: 21
        },
        end: {
          line: 150,
          column: 40
        }
      },
      "65": {
        start: {
          line: 151,
          column: 22
        },
        end: {
          line: 151,
          column: 98
        }
      },
      "66": {
        start: {
          line: 152,
          column: 15
        },
        end: {
          line: 152,
          column: 86
        }
      },
      "67": {
        start: {
          line: 153,
          column: 15
        },
        end: {
          line: 166,
          column: 5
        }
      },
      "68": {
        start: {
          line: 168,
          column: 16
        },
        end: {
          line: 168,
          column: 98
        }
      },
      "69": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 172,
          column: 5
        }
      },
      "70": {
        start: {
          line: 171,
          column: 6
        },
        end: {
          line: 171,
          column: 112
        }
      },
      "71": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 178,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 42
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 24
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 39,
            column: 3
          }
        },
        loc: {
          start: {
            line: 39,
            column: 22
          },
          end: {
            line: 42,
            column: 3
          }
        },
        line: 39
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 44,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        loc: {
          start: {
            line: 44,
            column: 53
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 44
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 48,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        loc: {
          start: {
            line: 48,
            column: 12
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 48
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 55,
            column: 16
          },
          end: {
            line: 55,
            column: 17
          }
        },
        loc: {
          start: {
            line: 55,
            column: 36
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 55
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 63,
            column: 2
          },
          end: {
            line: 63,
            column: 3
          }
        },
        loc: {
          start: {
            line: 63,
            column: 38
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 63
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 67,
            column: 2
          },
          end: {
            line: 67,
            column: 3
          }
        },
        loc: {
          start: {
            line: 67,
            column: 25
          },
          end: {
            line: 71,
            column: 3
          }
        },
        line: 67
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 73,
            column: 2
          },
          end: {
            line: 73,
            column: 3
          }
        },
        loc: {
          start: {
            line: 73,
            column: 52
          },
          end: {
            line: 79,
            column: 3
          }
        },
        line: 73
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 81,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        loc: {
          start: {
            line: 81,
            column: 53
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 81
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 3
          }
        },
        loc: {
          start: {
            line: 88,
            column: 49
          },
          end: {
            line: 97,
            column: 3
          }
        },
        line: 88
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 3
          }
        },
        loc: {
          start: {
            line: 99,
            column: 17
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 99
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 15
          },
          end: {
            line: 132,
            column: 3
          }
        },
        line: 109
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 134,
            column: 3
          }
        },
        loc: {
          start: {
            line: 134,
            column: 11
          },
          end: {
            line: 179,
            column: 3
          }
        },
        line: 134
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 42
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 42
          }
        }],
        line: 41
      },
      "1": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 98
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 98
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 98
          }
        }],
        line: 45
      },
      "2": {
        loc: {
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 8
          },
          end: {
            line: 45,
            column: 27
          }
        }, {
          start: {
            line: 45,
            column: 31
          },
          end: {
            line: 45,
            column: 67
          }
        }],
        line: 45
      },
      "3": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 39
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 39
          }
        }],
        line: 50
      },
      "4": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 53
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 53
          }
        }],
        line: 51
      },
      "5": {
        loc: {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 49
          }
        }, {
          start: {
            line: 56,
            column: 4
          },
          end: {
            line: 56,
            column: 49
          }
        }],
        line: 56
      },
      "6": {
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 56,
            column: 14
          }
        }, {
          start: {
            line: 56,
            column: 18
          },
          end: {
            line: 56,
            column: 36
          }
        }],
        line: 56
      },
      "7": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 53
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 53
          }
        }],
        line: 59
      },
      "8": {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 56
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 56
          }
        }],
        line: 68
      },
      "9": {
        loc: {
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 8
          },
          end: {
            line: 68,
            column: 13
          }
        }, {
          start: {
            line: 68,
            column: 17
          },
          end: {
            line: 68,
            column: 29
          }
        }],
        line: 68
      },
      "10": {
        loc: {
          start: {
            line: 69,
            column: 19
          },
          end: {
            line: 69,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 33
          },
          end: {
            line: 69,
            column: 57
          }
        }, {
          start: {
            line: 69,
            column: 60
          },
          end: {
            line: 69,
            column: 61
          }
        }],
        line: 69
      },
      "11": {
        loc: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }, {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 78,
            column: 5
          }
        }],
        line: 76
      },
      "12": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }],
        line: 83
      },
      "13": {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 24
          }
        }, {
          start: {
            line: 83,
            column: 28
          },
          end: {
            line: 83,
            column: 40
          }
        }],
        line: 83
      },
      "14": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        }, {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 94,
            column: 5
          }
        }],
        line: 91
      },
      "15": {
        loc: {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 25
          }
        }, {
          start: {
            line: 96,
            column: 4
          },
          end: {
            line: 96,
            column: 25
          }
        }],
        line: 96
      },
      "16": {
        loc: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 74
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 74
          }
        }, {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 74
          }
        }],
        line: 101
      },
      "17": {
        loc: {
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 101,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 101,
            column: 22
          }
        }, {
          start: {
            line: 101,
            column: 26
          },
          end: {
            line: 101,
            column: 60
          }
        }],
        line: 101
      },
      "18": {
        loc: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 60
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 60
          }
        }],
        line: 113
      },
      "19": {
        loc: {
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 113,
            column: 8
          },
          end: {
            line: 113,
            column: 34
          }
        }, {
          start: {
            line: 113,
            column: 38
          },
          end: {
            line: 113,
            column: 47
          }
        }],
        line: 113
      },
      "20": {
        loc: {
          start: {
            line: 115,
            column: 21
          },
          end: {
            line: 115,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 33
          },
          end: {
            line: 115,
            column: 37
          }
        }, {
          start: {
            line: 115,
            column: 40
          },
          end: {
            line: 115,
            column: 56
          }
        }],
        line: 115
      },
      "21": {
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 25
          }
        }, {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 119,
            column: 25
          }
        }],
        line: 119
      },
      "22": {
        loc: {
          start: {
            line: 122,
            column: 17
          },
          end: {
            line: 122,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 38
          }
        }, {
          start: {
            line: 122,
            column: 41
          },
          end: {
            line: 122,
            column: 44
          }
        }],
        line: 122
      },
      "23": {
        loc: {
          start: {
            line: 127,
            column: 30
          },
          end: {
            line: 127,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 40
          },
          end: {
            line: 127,
            column: 53
          }
        }, {
          start: {
            line: 127,
            column: 56
          },
          end: {
            line: 127,
            column: 70
          }
        }],
        line: 127
      },
      "24": {
        loc: {
          start: {
            line: 127,
            column: 72
          },
          end: {
            line: 127,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 82
          },
          end: {
            line: 127,
            column: 89
          }
        }, {
          start: {
            line: 127,
            column: 92
          },
          end: {
            line: 127,
            column: 97
          }
        }],
        line: 127
      },
      "25": {
        loc: {
          start: {
            line: 148,
            column: 18
          },
          end: {
            line: 148,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 148,
            column: 40
          },
          end: {
            line: 148,
            column: 42
          }
        }, {
          start: {
            line: 148,
            column: 45
          },
          end: {
            line: 148,
            column: 56
          }
        }],
        line: 148
      },
      "26": {
        loc: {
          start: {
            line: 149,
            column: 19
          },
          end: {
            line: 149,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 149,
            column: 19
          },
          end: {
            line: 149,
            column: 36
          }
        }, {
          start: {
            line: 149,
            column: 40
          },
          end: {
            line: 149,
            column: 46
          }
        }],
        line: 149
      },
      "27": {
        loc: {
          start: {
            line: 151,
            column: 22
          },
          end: {
            line: 151,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 151,
            column: 33
          },
          end: {
            line: 151,
            column: 56
          }
        }, {
          start: {
            line: 151,
            column: 59
          },
          end: {
            line: 151,
            column: 98
          }
        }],
        line: 151
      },
      "28": {
        loc: {
          start: {
            line: 151,
            column: 70
          },
          end: {
            line: 151,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 151,
            column: 70
          },
          end: {
            line: 151,
            column: 76
          }
        }, {
          start: {
            line: 151,
            column: 80
          },
          end: {
            line: 151,
            column: 97
          }
        }],
        line: 151
      },
      "29": {
        loc: {
          start: {
            line: 152,
            column: 37
          },
          end: {
            line: 152,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 152,
            column: 37
          },
          end: {
            line: 152,
            column: 47
          }
        }, {
          start: {
            line: 152,
            column: 51
          },
          end: {
            line: 152,
            column: 85
          }
        }],
        line: 152
      },
      "30": {
        loc: {
          start: {
            line: 168,
            column: 49
          },
          end: {
            line: 168,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 49
          },
          end: {
            line: 168,
            column: 59
          }
        }, {
          start: {
            line: 168,
            column: 63
          },
          end: {
            line: 168,
            column: 97
          }
        }],
        line: 168
      },
      "31": {
        loc: {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }, {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }],
        line: 170
      },
      "32": {
        loc: {
          start: {
            line: 175,
            column: 48
          },
          end: {
            line: 175,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 175,
            column: 48
          },
          end: {
            line: 175,
            column: 55
          }
        }, {
          start: {
            line: 175,
            column: 59
          },
          end: {
            line: 175,
            column: 71
          }
        }],
        line: 175
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Textarea/Textarea.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import config, { isRTL } from '../config';
import { PureComponent } from '../component';
import { inputClass } from '../Input/styles';
import cleanProps from '../utils/cleanProps';
import InputTitle from '../InputTitle';
import { inputTitleClass } from '../InputTitle/styles';
var DefaultProps = (cov_crec7426n.s[0]++, {
  rows: 4,
  resize: false
});

var Textarea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Textarea, _PureComponent);

  var _super = _createSuper2(Textarea);

  function Textarea(props) {
    var _this;

    _classCallCheck(this, Textarea);

    cov_crec7426n.f[0]++;
    cov_crec7426n.s[1]++;
    _this = _super.call(this, props);
    _this.shadow = void 0;

    _this.defaultInfo = function (value) {
      cov_crec7426n.f[4]++;
      cov_crec7426n.s[20]++;

      if ((cov_crec7426n.b[6][0]++, !value) || (cov_crec7426n.b[6][1]++, value.length === 0)) {
        cov_crec7426n.b[5][0]++;
        cov_crec7426n.s[21]++;
        return null;
      } else {
        cov_crec7426n.b[5][1]++;
      }

      var _ref = (cov_crec7426n.s[22]++, _this.props),
          info = _ref.info;

      var text = (cov_crec7426n.s[23]++, "".concat(value.length, " / ").concat(info));
      cov_crec7426n.s[24]++;

      if (value.length <= info) {
        cov_crec7426n.b[7][0]++;
        cov_crec7426n.s[25]++;
        return text;
      } else {
        cov_crec7426n.b[7][1]++;
      }

      cov_crec7426n.s[26]++;
      return new Error(text);
    };

    cov_crec7426n.s[2]++;
    _this.state = {
      height: 0
    };
    cov_crec7426n.s[3]++;
    _this.bindShadow = _this.bindShadow.bind(_assertThisInitialized(_this));
    cov_crec7426n.s[4]++;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    cov_crec7426n.s[5]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_crec7426n.s[6]++;
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    cov_crec7426n.s[7]++;
    _this.resize = _this.resize.bind(_assertThisInitialized(_this));
    cov_crec7426n.s[8]++;
    _this.defaultInfo = _this.defaultInfo.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_crec7426n.f[1]++;
      cov_crec7426n.s[9]++;

      _get(_getPrototypeOf(Textarea.prototype), "componentDidMount", this).call(this);

      cov_crec7426n.s[10]++;

      if (this.props.autosize) {
        cov_crec7426n.b[0][0]++;
        cov_crec7426n.s[11]++;
        this.resize();
      } else {
        cov_crec7426n.b[0][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      cov_crec7426n.f[2]++;
      cov_crec7426n.s[12]++;

      if ((cov_crec7426n.b[2][0]++, this.props.autosize) && (cov_crec7426n.b[2][1]++, prevProps.value !== this.props.value)) {
        cov_crec7426n.b[1][0]++;
        cov_crec7426n.s[13]++;
        this.resize(this.props.value);
      } else {
        cov_crec7426n.b[1][1]++;
      }
    }
  }, {
    key: "getTrim",
    value: function getTrim() {
      cov_crec7426n.f[3]++;

      var _ref2 = (cov_crec7426n.s[14]++, this.props),
          trim = _ref2.trim;

      cov_crec7426n.s[15]++;

      if (trim !== undefined) {
        cov_crec7426n.b[3][0]++;
        cov_crec7426n.s[16]++;
        return trim;
      } else {
        cov_crec7426n.b[3][1]++;
      }

      cov_crec7426n.s[17]++;

      if (config.trim !== undefined) {
        cov_crec7426n.b[4][0]++;
        cov_crec7426n.s[18]++;
        return config.trim;
      } else {
        cov_crec7426n.b[4][1]++;
      }

      cov_crec7426n.s[19]++;
      return false;
    }
  }, {
    key: "bindShadow",
    value: function bindShadow(el) {
      cov_crec7426n.f[5]++;
      cov_crec7426n.s[27]++;
      this.shadow = el;
    }
  }, {
    key: "resize",
    value: function resize(value) {
      cov_crec7426n.f[6]++;
      cov_crec7426n.s[28]++;

      if ((cov_crec7426n.b[9][0]++, value) || (cov_crec7426n.b[9][1]++, value === '')) {
        cov_crec7426n.b[8][0]++;
        cov_crec7426n.s[29]++;
        this.shadow.value = value;
      } else {
        cov_crec7426n.b[8][1]++;
      }

      var height = (cov_crec7426n.s[30]++, this.shadow ? (cov_crec7426n.b[10][0]++, this.shadow.scrollHeight) : (cov_crec7426n.b[10][1]++, 0));
      cov_crec7426n.s[31]++;
      this.setState({
        height: height
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      cov_crec7426n.f[7]++;
      cov_crec7426n.s[32]++;
      this.props.onChange(e.target.value);
      cov_crec7426n.s[33]++;

      if (this.props.autosize) {
        cov_crec7426n.b[11][0]++;
        cov_crec7426n.s[34]++;
        this.resize(e.target.value);
      } else {
        cov_crec7426n.b[11][1]++;
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      cov_crec7426n.f[8]++;

      var _ref3 = (cov_crec7426n.s[35]++, this.props),
          onEnterPress = _ref3.onEnterPress;

      cov_crec7426n.s[36]++;

      if ((cov_crec7426n.b[13][0]++, e.keyCode === 13) && (cov_crec7426n.b[13][1]++, onEnterPress)) {
        cov_crec7426n.b[12][0]++;
        cov_crec7426n.s[37]++;
        onEnterPress(e.target.value, e);
      } else {
        cov_crec7426n.b[12][1]++;
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      cov_crec7426n.f[9]++;
      var newValue = (cov_crec7426n.s[38]++, e.target.value);

      var _ref4 = (cov_crec7426n.s[39]++, this.props),
          forceChange = _ref4.forceChange,
          onBlur = _ref4.onBlur;

      cov_crec7426n.s[40]++;

      if (this.getTrim()) {
        cov_crec7426n.b[14][0]++;
        cov_crec7426n.s[41]++;
        newValue = newValue.trim();
        cov_crec7426n.s[42]++;
        e.target.value = newValue;
      } else {
        cov_crec7426n.b[14][1]++;
      }

      cov_crec7426n.s[43]++;
      forceChange(newValue);
      cov_crec7426n.s[44]++;

      if (onBlur) {
        cov_crec7426n.b[15][0]++;
        cov_crec7426n.s[45]++;
        onBlur(e);
      } else {
        cov_crec7426n.b[15][1]++;
      }
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      cov_crec7426n.f[10]++;

      var _ref5 = (cov_crec7426n.s[46]++, this.props),
          renderFooter = _ref5.renderFooter,
          value = _ref5.value;

      cov_crec7426n.s[47]++;

      if (!((cov_crec7426n.b[17][0]++, renderFooter) && (cov_crec7426n.b[17][1]++, typeof renderFooter === 'function'))) {
        cov_crec7426n.b[16][0]++;
        cov_crec7426n.s[48]++;
        return null;
      } else {
        cov_crec7426n.b[16][1]++;
      }

      cov_crec7426n.s[49]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: "footer",
          className: inputClass('footer'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103,
            columnNumber: 7
          }
        }, renderFooter(value))
      );
    }
  }, {
    key: "renderInfo",
    value: function renderInfo() {
      cov_crec7426n.f[11]++;

      var _ref6 = (cov_crec7426n.s[50]++, this.props),
          info = _ref6.info;

      var notNumber = (cov_crec7426n.s[51]++, typeof info !== 'number');
      cov_crec7426n.s[52]++;

      if ((cov_crec7426n.b[19][0]++, typeof info !== 'function') && (cov_crec7426n.b[19][1]++, notNumber)) {
        cov_crec7426n.b[18][0]++;
        cov_crec7426n.s[53]++;
        return null;
      } else {
        cov_crec7426n.b[18][1]++;
      }

      var textInfo = (cov_crec7426n.s[54]++, notNumber ? (cov_crec7426n.b[20][0]++, info) : (cov_crec7426n.b[20][1]++, this.defaultInfo));
      var res = (cov_crec7426n.s[55]++, textInfo(this.props.value)); // empty

      cov_crec7426n.s[56]++;

      if (!res) {
        cov_crec7426n.b[21][0]++;
        cov_crec7426n.s[57]++;
        return null;
      } else {
        cov_crec7426n.b[21][1]++;
      }

      var isError = (cov_crec7426n.s[58]++, res instanceof Error);
      var text = (cov_crec7426n.s[59]++, isError ? (cov_crec7426n.b[22][0]++, res.message) : (cov_crec7426n.b[22][1]++, res));
      cov_crec7426n.s[60]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: "info",
          style: {
            minWidth: 'auto'
          },
          className: inputClass(isRTL() ? (cov_crec7426n.b[23][0]++, 'bottom-left') : (cov_crec7426n.b[23][1]++, 'bottom-right'), isError ? (cov_crec7426n.b[24][0]++, 'error') : (cov_crec7426n.b[24][1]++, 'tip')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 124,
            columnNumber: 7
          }
        }, text)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_crec7426n.f[12]++;

      var _ref7 = (cov_crec7426n.s[61]++, this.props),
          autosize = _ref7.autosize,
          onChange = _ref7.onChange,
          maxHeight = _ref7.maxHeight,
          info = _ref7.info,
          onEnterPress = _ref7.onEnterPress,
          resize = _ref7.resize,
          renderFooter = _ref7.renderFooter,
          inputFocus = _ref7.inputFocus,
          innerTitle = _ref7.innerTitle,
          placeTitle = _ref7.placeTitle,
          props = _objectWithoutProperties(_ref7, ["autosize", "onChange", "maxHeight", "info", "onEnterPress", "resize", "renderFooter", "inputFocus", "innerTitle", "placeTitle"]);

      var value = (cov_crec7426n.s[62]++, props.value == null ? (cov_crec7426n.b[25][0]++, '') : (cov_crec7426n.b[25][1]++, props.value));
      var height = (cov_crec7426n.s[63]++, (cov_crec7426n.b[26][0]++, this.state.height) || (cov_crec7426n.b[26][1]++, 'auto'));
      var footerEl = (cov_crec7426n.s[64]++, this.renderFooter());
      var className = (cov_crec7426n.s[65]++, autosize ? (cov_crec7426n.b[27][0]++, inputClass('auto-size')) : (cov_crec7426n.b[27][1]++, inputClass((cov_crec7426n.b[28][0]++, resize) && (cov_crec7426n.b[28][1]++, 'textarea-resize'))));
      var cs = (cov_crec7426n.s[66]++, classnames(className, (cov_crec7426n.b[29][0]++, innerTitle) && (cov_crec7426n.b[29][1]++, inputTitleClass('hidable', 'item'))));
      var ts = (cov_crec7426n.s[67]++, [
      /*#__PURE__*/
      React.createElement("textarea", Object.assign({}, cleanProps(props), {
        key: "t",
        value: value,
        className: cs,
        style: {
          height: height,
          maxHeight: maxHeight,
          overflow: 'auto'
        },
        onChange: this.handleChange,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154,
          columnNumber: 7
        }
      })), footerEl, this.renderInfo()]);
      var cs2 = (cov_crec7426n.s[68]++, classnames(inputClass('shadow'), (cov_crec7426n.b[30][0]++, innerTitle) && (cov_crec7426n.b[30][1]++, inputTitleClass('hidable', 'item'))));
      cov_crec7426n.s[69]++;

      if (autosize) {
        cov_crec7426n.b[31][0]++;
        cov_crec7426n.s[70]++;
        ts.push(
        /*#__PURE__*/
        React.createElement("textarea", {
          key: "s",
          ref: this.bindShadow,
          className: cs2,
          rows: props.rows,
          defaultValue: value,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 171,
            columnNumber: 15
          }
        }));
      } else {
        cov_crec7426n.b[31][1]++;
      }

      cov_crec7426n.s[71]++;
      return (
        /*#__PURE__*/
        React.createElement(InputTitle, {
          innerTitle: innerTitle,
          open: (cov_crec7426n.b[32][0]++, !!value) || (cov_crec7426n.b[32][1]++, !!inputFocus),
          placeTitle: placeTitle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 175,
            columnNumber: 7
          }
        }, ts)
      );
    }
  }]);

  return Textarea;
}(PureComponent);

Textarea.defaultProps = DefaultProps;
export default Textarea;